module.exports = __webpack_public_path__ + "img/shipo-sales-plan-arrow-down.4ea813c1.svg";